export default "__VITE_ASSET__C$CmXVfl__"